import classNames from 'classnames';
import { VrmLookupModal } from '$quantum/molecules/VrmLookupModal';

export default function CoveredModalContent({ className = '', ...props }) {
  return (
    <div {...props} className={classNames('CoveredModalContent', className)}>
      <div className="title">Great news! We&#39;ve got you covered.</div>
      <div className="content">Find out what repairs and services you can book.</div>
      <VrmLookupModal size="L">Get instant quote‰</VrmLookupModal>
    </div>
  );
}
